import { type LucideIcon, Box, GitBranch, Package } from 'lucide-react';

import {
  GithubComPortainerPortainerApiGitopsWorkflowsStatus,
  SourcesSourceType,
  SourcesSource,
} from '@api/types.gen';

export type SourceStatus = GithubComPortainerPortainerApiGitopsWorkflowsStatus;
export type SourceType = SourcesSourceType;
export type Source = SourcesSource;
export type SourceId = Source['id'];

export const SOURCE_TYPES: Record<
  SourceType,
  { label: string; icon: LucideIcon }
> = {
  git: { label: 'Git', icon: GitBranch },
  helm: { label: 'Helm', icon: Package },
  oci: { label: 'OCI', icon: Box },
};
